import BaseModel from '@/data/models/base/base-model';
import TypeUtils from '@/helpers/type-utils';
import dayjs from "dayjs";

export default class MeterModelForm extends BaseModel {
  startDate: Date;
  endDate: Date;
  buildingId: string;
  meterId: string;

  static map(data: Partial<MeterModelForm>): MeterModelForm | null {
    if (!data) {
      return null;
    }

    const meterModelForm = new MeterModelForm();

    meterModelForm.id = TypeUtils.hasStringOrDefault(data.id);
    meterModelForm.meterId = TypeUtils.hasStringOrDefault(data.meterId);
    meterModelForm.buildingId = TypeUtils.hasStringOrDefault(data.buildingId);
    meterModelForm.startDate = TypeUtils.hasDateOrDefault(data.startDate, dayjs().toDate());
    meterModelForm.endDate = TypeUtils.hasDateOrDefault(data.endDate, dayjs().toDate());

    return meterModelForm;
  }

  toJSON(): Partial<MeterModelForm> {
    return {
      'startDate': this.startDate,
      'endDate': this.endDate,
      'buildingId': this.buildingId,
      'meterId': this.meterId,
    };
  }

  toJsonSingle(): Partial<MeterModelForm> {
    return {
      'startDate': this.startDate,
      'endDate': this.endDate,
      'buildingId': this.buildingId,
    };
  }

}
